import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {SupplierPriceList} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromSupplierPriceList = (
  supplierPriceLists: SupplierPriceList[] | Nullish,
  supplierId: string | Nullish
): Option[] => {
  if (isNil(supplierPriceLists)) {
    return [];
  }

  const filtered = isNil(supplierId)
    ? supplierPriceLists
    : supplierPriceLists.filter((supplierPriceLis) => supplierPriceLis.supplierId === supplierId);

  return filtered.map((supplierPriceList) => ({
    label: supplierPriceList.priceListName,
    value: supplierPriceList.priceListId,
  }));
};
